'use client';

import { useEffect, useState } from 'react';
import s from './Halloween.module.css';

// Resolved after mount so SSR markup never differs, and so it follows the visitor's local date.
export function useIsHalloween() {
  const [isHalloween, setIsHalloween] = useState(false);
  useEffect(() => {
    const now = new Date();
    setIsHalloween(now.getMonth() === 9 && now.getDate() === 31);
  }, []);
  return isHalloween;
}

// Needs a positioned parent; sits over the logo's top-right corner.
export function HalloweenBat() {
  return (
    <span className={s.bat} aria-hidden="true">
      🦇
    </span>
  );
}
